import { accountsSelectors } from 'app-components/flux/accounts';
import { getCategoriesById } from 'app-components/flux/categories/categoriesSelectors';
import { tagsSelectors } from 'app-components/flux/tags';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import type RootState from 'app-components/utils/redux-store/rootState';

import { getAllowedCategoriesForAI, getCoaInfoWithMaps } from '../../../tools/utils';
import type { CleanupTransactionEligibleTransaction } from './types';

const buildCleanupTransactionAllowedTags = (state: RootState): string[] =>
  tagsSelectors
    .getResourcesById(state)
    .valueSeq()
    .map((tag) => tag.name)
    .filter((name): name is string => !!name)
    .toArray();

export const buildCleanupTransactionEligibleSnapshot = (
  state: RootState,
  transactionId: string,
  txn: TransactionRecord,
): CleanupTransactionEligibleTransaction => {
  const coaInfo = getCoaInfoWithMaps(txn.coa, {
    categoriesById: getCategoriesById(state),
    accountsById: accountsSelectors.getAccountsById(state),
  });

  return {
    transactionId,
    payee: txn.payee ?? '',
    date: txn.postedOn,
    amount: txn.amount,
    memo: txn.memo ?? '',
    tags: txn.tags
      ? (Array.isArray(txn.tags) ? txn.tags : txn.tags.toArray())
          .map((tag) => tag.name)
          .filter((name): name is string => !!name)
      : [],
    userFlag: txn.userFlag ?? 'NONE',
    currentCategoryName: coaInfo.name,
    categoryId: coaInfo.id,
    allowedCategories: getAllowedCategoriesForAI(state),
    allowedTags: buildCleanupTransactionAllowedTags(state),
  };
};
